export default __webpack_public_path__ + "static/media/keyboard_arrow_down.c19deb78.svg";